import type {
  Collaborator,
  GetCollaboratorsResponseType,
} from "@nlc/shared-types";

import { type DefaultError, useQuery } from "@tanstack/react-query";

import { MOCKED_COLLABORATORS } from "@/features/templates/mocks/collaborators.ts";
import { collaboratorsKeys } from "@/hooks/queryKeys.ts";
import { useGetCurrentProjectId } from "@/hooks/useGetCurrentProjectId.tsx";
import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import apiClient from "@/lib/api/client.ts";

export function useGetProjectCollaborators(projectIdOverride?: number) {
  const currentProjectId = useGetCurrentProjectId();
  const projectId = projectIdOverride ?? currentProjectId;
  const { isTemplate } = useIsTemplate();

  return useQuery<GetCollaboratorsResponseType, DefaultError, Collaborator[]>({
    enabled: !!projectId || isTemplate,
    queryFn: async () => {
      if (isTemplate) {
        return MOCKED_COLLABORATORS;
      }

      return apiClient.url(`/projects/${projectId}/collaborators`).get().json();
    },
    queryKey: collaboratorsKeys.collaboratorsByProjectId(projectId),
    select: (data) =>
      data.collaborators.map(({ avatar, brandIds, id, name, roleId }) => ({
        brandIds,
        id: id,
        profilePicture: avatar,
        roleId,
        textValue: name,
      })),
  });
}
